<script setup lang="ts">
import { ref, onBeforeMount } from "vue";
import { useApiClient } from "@/api/client";
import IntegrationDO = App.Data.Integrations.IntegrationDO;

const availableIntegrations = ref<IntegrationDO[]>([]);

const itemsPerPage = ref(100);
const page = ref(1);
const sortBy = ref([]);

const getIntegrations = async () => {
	const response = await useApiClient("integrations").get({
		page: page.value,
		itemsPerPage: itemsPerPage.value,
		sortBy: sortBy.value,
	});

	if (response.isOk()) {
		availableIntegrations.value = response.value.data;
	}
};

onBeforeMount(() => getIntegrations());
</script>

<template>
	<div class="pt-5 integrations-grid">
		<v-card
			v-for="availableIntegration in availableIntegrations"
			:key="availableIntegration.uuid"
			class="integration-card"
		>
			<v-sheet color="grey-lighten-4" class="position-relative">
				<div class="integration-status">
					<v-chip
						v-if="availableIntegration.is_configured_correctly"
						color="success"
						prepend-icon="fa: fa-light fa-link"
						density="compact"
					>
						Connected
					</v-chip>
					<v-chip
						v-else
						color="warning"
						prepend-icon="fa: fa-light fa-link-slash"
						density="compact"
					>
						Not Connected
					</v-chip>
				</div>

				<v-img height="200" :src="availableIntegration.company_logo" cover />
			</v-sheet>

			<v-divider class="mb-3" />

			<v-card-title>
				{{ availableIntegration.company_name }}
			</v-card-title>

			<v-card-subtitle>
				{{ availableIntegration.category }}
			</v-card-subtitle>

			<v-card-actions>
				<v-spacer />
				<v-btn
					color="primary"
					variant="flat"
					text="Manage"
					:to="`/integrations/manage/${availableIntegration.uuid}`"
				/>
			</v-card-actions>
		</v-card>
	</div>
</template>

<style scoped>
.integrations-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(344px, 1fr));
	gap: 24px;
	align-items: start;
}

.integration-card {
	max-width: 344px;
	min-width: 344px;
	justify-self: start;
}

.integration-status {
	position: absolute;
	right: 16px;
	top: 16px;
	z-index: 1;
}
</style>
